import React, { useRef, useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectFade, Autoplay } from "swiper/modules";
import BadgeGroup from "./BadgeGroup";


export default function MainSlider({ slidesData = [], badges = [] }) {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [swiperInstance, setSwiperInstance] = useState(null);

    useEffect(() => {
        if (swiperInstance && prevRef.current && nextRef.current) {
            swiperInstance.params.navigation.prevEl = prevRef.current;
            swiperInstance.params.navigation.nextEl = nextRef.current;
            swiperInstance.navigation.init();
            swiperInstance.navigation.update();
        }
    }, [swiperInstance]);

    return (
        <div className="main-slider">
            <Swiper
                modules={[Navigation, EffectFade, Autoplay]}
                effect="fade"
                autoplay={{ delay: 5000 }}
                loop={true}
                slidesPerView={1}
                onSwiper={setSwiperInstance}
                className="main-slider__main"
            >
                {slidesData.map((slide, idx) => (
                    <SwiperSlide key={idx}>
                        <div className="slider-media">
                            <picture className="picture loading">
                                <source srcSet={slide.image} media="(min-width: 768px)" />
                                <source srcSet={slide.image} />
                                <img
                                    src={slide.image}
                                    loading="lazy"
                                    alt={slide.alt}
                                    className="lazy slider-image loading"
                                />
                            </picture>
                        </div>
                        <div className="slider-body">
                            <div className="container">
                                <div className="slider-content">
                                    <h2 className="slider-title mb-4 mb-md-3 mb-lg-5">
                                        {slide.titleLines.map((line, i) => (
                                            <p key={i}>{i === 1 ? <span>{line}</span> : line}</p>
                                        ))}
                                    </h2>
                                    {slide.link &&
                                        <a href={slide.link} className="hero-section__button">
                                            <span>Projeyi Keşfet</span>
                                        </a>
                                    }
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <BadgeGroup badges={badges} />

            <div className="main-slider__logos">
                <div className="d-none d-lg-flex main-slider__buttons">
                    <div className="btn-swiper swiper-button-prev p-4 m-1" onClick={() => swiperInstance?.slidePrev()} />
                    <div className="btn-swiper swiper-button-next p-4 m-1" onClick={() => swiperInstance?.slideNext()} />
                </div>
            </div>

            <div className="scroll-arrow-wrap">
                <span className="scroll-arrow">
                    <svg viewBox="0 0 24 24">
                        <polyline points="6 10 12 16 18 10" />
                    </svg>
                </span>
            </div>

        </div>
    );
}
